<app-lms-stats></app-lms-stats>

<div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0" fxLayoutGap.md="0">

    <div fxFlex="66.666666%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">

        <app-lms-progress></app-lms-progress>

        <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0">
            <div fxFlex="70%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.lg="67%" class="col">

                <app-lms-hours-spent></app-lms-hours-spent>

                <app-lms-instructors></app-lms-instructors>

            </div>
            <div fxFlex="30%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.lg="33%" class="col">

                <app-lms-planning></app-lms-planning>

                <app-lms-status></app-lms-status>

            </div>
        </div>
        
        <app-lms-current-courses></app-lms-current-courses>

        <app-lms-enrolled-created></app-lms-enrolled-created>
        
    </div>

    <div fxFlex="33.333333%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">

        <app-lms-experience></app-lms-experience>

        <app-lms-active-course></app-lms-active-course>

        <app-lms-course-completion></app-lms-course-completion>

        <app-lms-messages></app-lms-messages>

        <app-lms-students></app-lms-students>

    </div>

</div>